(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('backTo', BackTo)

    /** @ngInject */
    function BackTo(PATHS) {
        function BackToController($stateParams) {
            const vm = this;

            vm.init = () => {
                vm.hasNews = false;

                if ($stateParams.NewsId && $stateParams.NewsTitle) {
                    vm.news = {
                        Id: $stateParams.NewsId,
                        Title: $stateParams.NewsTitle
                    }

                    vm.hasNews = true;
                }
            }
        }

        function link(scope, attrs, elem, ctrl) {
            ctrl.init();
        }

        return {
            bindToController: true,
            controller: BackToController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/back-to/back-to.html`,
            link: link,
            scope: {
                noMargin: '='
            }
        }
    }
}());